// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating Ward model structure.
 * @see #/components/schemas/Ward - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface Ward {
    /**
     * Ward unique id.
     * @dataFormat uuid
     */
    id: string;
    /**
     * The name of the ward.
     *
     */
    name: string;
    /**
     * Status of the ward.  * `active` - ACTIVE * `suspended` - SUSPENDED * `inactive` - INACTIVE
     *
     */
    status: Ward.StatusEnum;
    /**
     * The display name of the ward.
     *
     */
    display_name: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for Ward
 */
export namespace Ward {
    export type StatusEnum = 'active' | 'suspended' | 'inactive';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Suspended: 'suspended' as StatusEnum,
        Inactive: 'inactive' as StatusEnum,
    };

    /**
     * Ward Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Ward unique id.
         * @dataFormat uuid
         */
        id: string;
        /**
         * The name of the ward.
         * @type string (`dataFormat` is missing)
         */
        name: string;
        /**
         * Status of the ward.  * `active` - ACTIVE * `suspended` - SUSPENDED * `inactive` - INACTIVE
         * @type string (`dataFormat` is missing)
         */
        status: Ward.StatusEnum;
        /**
         * The display name of the ward.
         * @type string (`dataFormat` is missing)
         */
        displayName: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * Ward DTO
     * Transforms Ward model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend Ward model */
        static toModel(obj: Ward): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend Ward model */
        static toApi(obj: Model): Ward {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as Ward;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
